import Moment from 'moment'
import {
    ActivityMediums,
    ActivityMediumsKeyValueList,
    ActivityResource,
    ActivitySchema
} from "../../classes/Api/Activity";

export default {
    filters: {
        activityIcon(value) {
            const item = ActivityMediumsKeyValueList.find(item => {
                return item.value === value.medium
            })

            if (item) {
                return item.icon
            }
        }
    },
    methods: {
        newActivityForContact(contact) {
            return new ActivitySchema({
                contact_id: contact.id,
                contact: contact,
                medium: ActivityMediums.CALL,
                due_at: Moment().add(1, 'day').hours(9).minutes(0).seconds(0).toDate(),
                owner_id: window.marque.ui.user.id,
                owner: window.marque.ui.user,
            })
        },
        newActivityForLead(lead) {
            console.log(lead)
            return new ActivitySchema({
                lead_id: lead.id,
                lead: lead,
                contact_id: lead.contact.id,
                contact: lead.contact,
                medium: ActivityMediums.CALL,
                due_at: Moment().add(1, 'day').hours(9).minutes(0).seconds(0).toDate(),
                owner_id: lead.sales_person.id,
                owner: lead.sales_person,
            })
        },
        isPassedDue(activity) {
            return !!(activity && Moment(activity.due_at).isBefore(Moment()));
        },
        hasOverdueActivity(lead) {
            return lead.activities.filter(item => {
                return !item.completed_at
            }).filter(item => {
                return Moment().isAfter(item.due_at)
            }).length > 0
        },
        firstIncompleteActivity(lead) {
            let acts = lead.activities.filter(item => {
                return !item.completed_at
            })

            if (acts && acts.length > 0) {
                acts = _.sortBy(acts, 'due_at')
                return acts[0]
            }
        },
        toggleActivity: _.debounce(function(activity, callback = null) {
            let done = !!activity.completed_at
            let promise

            if (!done) {
                promise = ActivityResource.complete(activity.id)
            } else {
                promise = ActivityResource.uncomplete(activity.id)
            }

            promise.then((response) => {
                activity.completed_at = response.data.completed_at

                if (callback) {
                    callback(activity)
                }
            })
        })
    }
}